import SnapshotsButtonModal from "./SnapshotsButtonModal";

export default SnapshotsButtonModal;
